module.exports = __webpack_public_path__ + "static/media/lafourchette-1.b4bdee53.png";